/**
 * @file  FormItem/index.tsx
 * @description
 *
 * @example
 *
 * @author dlima (dlima-electron)
 *
 */

import React from 'react';
import * as S from './styles';

export const Column = ({
  span,
  sm,
  xs,
  md,
  className,
  children
}: S.Props): JSX.Element => {
  return (
    <S.Col
      span={span}
      sm={sm ?? 24}
      xs={xs ?? 24}
      md={md ?? span}
      className={className}
    >
      {children}
    </S.Col>
  );
};
